import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgeDialogComponent } from './Agedialog/AgeDialoag.component';
import { SearchDialogComponent } from './Searchdialog/SearchDialoag.component';
import { CampDialogComponent } from './Campdialog/CampDialoag.component';
import { GeneralDialoag } from './Generaldialog/GeneralDialoag.component';
 import {WebcamModule} from 'ngx-webcam';
import { PatientdocsComponent } from './patientdocs/patientdocs.component';
import { Webcam_photoComponent } from './webcam_photo/webcam_photo.component';
import { Patient_trackingComponent } from './patient_tracking/patient_tracking.component';
import { AutofocusDirective } from './CustomDirectives/auto-focus.directive';
import { Phoneno_confirmation_dialogComponent } from './phoneno_confirmation_dialog/phoneno_confirmation_dialog.component';
// import { MaterialModule} from '../material.module'
 import { SharedModule } from 'app/shared/shared.module';
import { MatFormFieldModule } from "@angular/material/form-field";
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { MatRowKeyboardSelectionDirective } from './Searchdialog/mat-row-keyboard-selection.directive';

@NgModule({
  imports: [
    WebcamModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
   // MaterialModule,
    SharedModule,
    MatFormFieldModule,
    IvyCarouselModule,
    
  ],
  declarations: [
    AutofocusDirective,
    AgeDialogComponent,
    SearchDialogComponent,
    CampDialogComponent, 
    GeneralDialoag,
    PatientdocsComponent,
    Patient_trackingComponent,
    Phoneno_confirmation_dialogComponent,
    Webcam_photoComponent,
    MatRowKeyboardSelectionDirective
  ],
  entryComponents:[
    AgeDialogComponent,
    SearchDialogComponent,
    CampDialogComponent,
    GeneralDialoag,
    PatientdocsComponent, 
    Patient_trackingComponent,
    Phoneno_confirmation_dialogComponent,
    Webcam_photoComponent,
  ],
  exports:[
    Webcam_photoComponent
  ]
})
export class TableListModule { }
        
